module.exports = __webpack_public_path__ + "img/thumbmad4.1097ec6d.png";